import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PortalTextBox from '../../portal/portalTextBox';
import PortalCheckBox from '../../portal/controls/checkbox';
import PortalDropdown from '../../portal/portalDropdown';
import EncryptionTypes from '../../../services/encryption/encryptionTypes';
import { EncryptionTypesEnum } from '../../../services/enums/encryptionTypesEnum';
import { SmtpSettingsEditMode } from '../../../services/enums/smtpSettings';
import { Modal } from 'react-bootstrap';
import TestEmailForm from './testEmailForm';
import ScreenLoaderContainer from '../../portal/controls/screenLoaderContainer';
import { TransparentButton, Button, ButtonType } from '@checkmarx/cx-ui';
import TextfieldFloatingText from '../../portal/textfieldFloatingText';

@inject('translationsStore', 'smtpSettingsStore')
@observer
export default class SmtpSettings extends Component {

    componentDidMount() {

        this.props.smtpSettingsStore.setSaveSmtpSettingsErrorMessage('');
        this.props.smtpSettingsStore.emptyAllFieldValidationMessages();
        this.props.smtpSettingsStore.getSmtpSettings();
    }

    fieldWidth = '100%';

    handleHostChange = e => this.props.smtpSettingsStore.setHost(e.target.value);
    handleHostOnBlur = e => this.props.smtpSettingsStore.validateHost();

    handlePortChange = e => this.props.smtpSettingsStore.setPort(e.target.value);
    handlePortOnBlur = e => this.props.smtpSettingsStore.validatePort();

    handleFromAddressChange = e => this.props.smtpSettingsStore.setFromAddress(e.target.value);
    handleFromAddressOnBlur = e => this.props.smtpSettingsStore.validateFromAddress();

    handleFromDisplayNameChange = e => this.props.smtpSettingsStore.setFromDisplayName(e.target.value);

    handleEncryptionTypeChange = (e, index, value) => this.props.smtpSettingsStore.setEncryptionType(value);

    handlePasswordChange = e => this.props.smtpSettingsStore.setPassword(e.target.value);
    handlePasswordOnBlur = e => this.props.smtpSettingsStore.validatePassword();

    handleUseDefaultCredentialsChange = e => this.props.smtpSettingsStore.setUseDefaultCredentials(e.target.value);

    toggleUseDefaultCredentials = () => {

        let currentUseDefaultCredentials = this.props.smtpSettingsStore.values.useDefaultCredentials;
        this.props.smtpSettingsStore.setUseDefaultCredentials(!currentUseDefaultCredentials);
    }

    handleUsernameChange = e => this.props.smtpSettingsStore.setUsername(e.target.value);
    handleUserameOnBlur = e => this.props.smtpSettingsStore.validateUsername();

    state = {
        showTestEmailModal: false
    };

    closeTestEmailModal = (e) => {

        this.setState({
            showTestEmailModal: false
        });

        this.props.smtpSettingsStore.setTestSmtpEmailValidationMessage('');
        this.props.smtpSettingsStore.setSendTestEmailErrorMessage('');
    }

    openTestEmailModal = (e) => {

        this.props.smtpSettingsStore.setSaveSmtpSettingsErrorMessage('');
        const isValid = this.props.smtpSettingsStore.validateSmtpSettingsForm();

        if (isValid === false) {

            const validationErrorMessage = this.props.translationsStore.translate('SEE_ERRORS_BELOW');
            this.props.smtpSettingsStore.setSaveSmtpSettingsErrorMessage(validationErrorMessage);
            return;
        }

        this.setState({
            showTestEmailModal: true
        });
    }

    render() {

        const { values } = this.props.smtpSettingsStore;
        let component = null;

        if (this.props.smtpSettingsStore.values.smtpSettingsEditMode == undefined
            || this.props.smtpSettingsStore.values.smtpSettingsEditMode == SmtpSettingsEditMode.none) {

            component = <ScreenLoaderContainer />
        }
        else {

            component = <div>
                <div className='smtp-settings-inputs'>
                    <div className='smtp-settings-host-container'>
                        <div className='smtp-settings-host'>
                            <PortalTextBox
                                dataCy={'txt-smtp-settings-host'}
                                hintText={this.props.translationsStore.translate('SMTP_HOST')}
                                floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('SMTP_HOST')}
                                    required={true} />}
                                onChange={this.handleHostChange}
                                onBlur={this.handleHostOnBlur}
                                width={this.fieldWidth}
                                errorText={this.props.smtpSettingsStore.hostValidationMessage}
                                disabled={this.props.smtpSettingsStore.savingSmtpSettings}
                                value={values.host}
                            />
                        </div>
                        <div className='smtp-settings-port'>
                            <PortalTextBox
                                dataCy={'txt-smtp-settings-port'}
                                hintText={this.props.translationsStore.translate('PORT')}
                                floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('PORT')}
                                    required={true} />}
                                onChange={this.handlePortChange}
                                onBlur={this.handlePortOnBlur}
                                width={this.fieldWidth}
                                errorText={this.props.smtpSettingsStore.portValidationMessage}
                                disabled={this.props.smtpSettingsStore.savingSmtpSettings}
                                value={values.port}
                            />
                        </div>
                        <div className='smtp-settings-encryption-type'>
                            <PortalDropdown
                                dataCy={'txt-smtp-settings-encryption-type'}
                                hintText={this.props.translationsStore.translate('ENCRYPTION_TYPE')}
                                floatingLabelText={this.props.translationsStore.translate('ENCRYPTION_TYPE')}
                                onChange={this.handleEncryptionTypeChange}
                                items={EncryptionTypes}
                                fullWidth={true}
                                width={this.fieldWidth}
                                disabled={this.props.smtpSettingsStore.savingSmtpSettings}
                                value={values.encryptionType}
                            />
                        </div>
                    </div>
                    <div className='smtp-settings-host-from-container'>
                        <div className='smtp-settings-from-address'>
                            <PortalTextBox
                                dataCy={'txt-smtp-settings-from-address'}
                                hintText={this.props.translationsStore.translate('EMAIL_FROM_ADRESS')}
                                floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('EMAIL_FROM_ADRESS')}
                                    required={true} />}
                                onChange={this.handleFromAddressChange}
                                onBlur={this.handleFromAddressOnBlur}
                                width={this.fieldWidth}
                                errorText={this.props.smtpSettingsStore.fromAddressValidationMessage}
                                disabled={this.props.smtpSettingsStore.savingSmtpSettings}
                                value={values.fromAddress}
                            />
                        </div>
                        <div className='smtp-settings-from-display-name'>
                            <PortalTextBox
                                dataCy={'txt-smtp-settings-from-display-name'}
                                hintText={this.props.translationsStore.translate('EMAIL_FROM_DISPLAY_NAME')}
                                floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('EMAIL_FROM_DISPLAY_NAME')}
                                    required={false} />}
                                onChange={this.handleFromDisplayNameChange}
                                onBlur={this.handleFromDisplayNameOnBlur}
                                width={this.fieldWidth}
                                errorText={this.props.smtpSettingsStore.fromDisplayNameValidationMessage}
                                disabled={this.props.smtpSettingsStore.savingSmtpSettings}
                                value={values.displayName}
                            />
                        </div>
                    </div>
                    <div className='smtp-settings-defualt-credentials'>
                        <PortalCheckBox
                            dataCy={'tgl-smtp-settings-defualt-credentials'}
                            dataKey={'useDefualtCredentials'}
                            checked={values.useDefaultCredentials}
                            onCheck={this.toggleUseDefaultCredentials}
                            disabled={this.props.smtpSettingsStore.savingSmtpSettings}
                            label={this.props.translationsStore.translate('USE_DEFAULT_CREDENTIALS')}
                        />
                    </div>
                    <div className='smtp-settings-credentials'>
                        <div className='smtp-settings-username'>
                            <PortalTextBox
                                dataCy={'txt-smtp-settings-username'}
                                hintText={this.props.translationsStore.translate('USER_NAME')}
                                floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('USER_NAME')}
                                    required={!values.useDefaultCredentials} />}
                                onChange={this.handleUsernameChange}
                                onBlur={this.handleUserameOnBlur}
                                width={this.fieldWidth}
                                errorText={this.props.smtpSettingsStore.usernameValidationMessage}
                                disabled={this.props.smtpSettingsStore.savingSmtpSettings}
                                value={values.username}
                                disabled={values.useDefaultCredentials}
                            />
                        </div>
                        <div className='smtp-settings-password'>
                            <PortalTextBox
                                dataCy={'txt-smtp-settings-password'}
                                hintText={this.props.translationsStore.translate('PASSWORD')}
                                floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('PASSWORD')}
                                    required={!values.useDefaultCredentials} />}
                                type='password'
                                onChange={this.handlePasswordChange}
                                onBlur={this.handlePasswordOnBlur}
                                width={this.fieldWidth}
                                errorText={this.props.smtpSettingsStore.passwordValidationMessage}
                                value={values.password}
                                disabled={values.useDefaultCredentials || this.props.smtpSettingsStore.savingSmtpSettings}
                            />
                        </div>
                    </div>
                </div>
                <div className='smtp-settings-buttons'>
                    <div className='smtp-settings-test'>
                        <TransparentButton
                            style={{
                                height: 25,
                                lineHeight: '24px'
                            }}
                            type='button'
                            onClick={this.openTestEmailModal}
                            text={this.props.translationsStore.translate('SEND_TEST_EMAIL')}
                        />
                        <Modal key={2} dialogClassName='smtp-settings-test-modal'
                            show={this.state.showTestEmailModal}
                            onHide={this.closeTestEmailModal}>
                            <Modal.Header>
                                <Modal.Title>{this.props.translationsStore.translate('SEND_TEST_EMAIL')}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <TestEmailForm closeModal={this.closeTestEmailModal} />
                            </Modal.Body>
                        </Modal>
                    </div>
                    <div className='general-settings-submit'>
                        <Button
                            dataCy='btn-smtp-settings-submit'
                            type='submit'
                            inProgress={this.props.smtpSettingsStore.savingSmtpSettings}
                            text={this.props.translationsStore.translate('SAVE')} >
                        </Button>
                    </div>
                </div>
            </div>;
        }

        return (
            <div className='smtp-settings-form' data-cy='smtp-form'>
                <div className='general-settings-title'>
                    {this.props.translationsStore.translate('SMTP_SETTINGS_TITLE')}
                </div>
                <div className={'setting-sub-title'}>{this.props.translationsStore.translate('GENERAL_SMTP_SETTINGS_SUB_TITLE')}</div>
                {component}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/generalSettings/smtpSettings/index.jsx